/* Vardholm sections – shared interactions. Safe to load once per page; re-inits in the theme editor. */
(function(){
  if(window.VH) return;
  function qa(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));}
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); fire(e.target); io.unobserve(e.target);} });
  },{threshold:.18}) : null;

  function fire(el){
    qa('[data-vh-count]',el).forEach(countUp);
    if(el.hasAttribute('data-vh-count')) countUp(el);
    qa('.vh-stat__ring .fg',el).forEach(function(c){ var p=parseFloat(c.getAttribute('data-p')||0); c.style.strokeDashoffset = 345.6*(1-p/100); });
    qa('.vh-tl__fill',el).forEach(function(f){ f.style.height='100%'; });
  }
  function countUp(n){
    if(n._done) return; n._done=1;
    var to=parseFloat(n.getAttribute('data-vh-count'))||0, suf=n.getAttribute('data-suffix')||'', dur=1600, t0=null;
    function step(t){ if(!t0)t0=t; var k=Math.min(1,(t-t0)/dur); k=1-Math.pow(1-k,3);
      n.textContent=(to%1?(to*k).toFixed(1):Math.round(to*k)).toLocaleString()+suf; if(k<1) requestAnimationFrame(step);}
    requestAnimationFrame(step);
  }

  function initReveal(root){
    qa('.vh-reveal',root).forEach(function(el){ if(io) io.observe(el); else { el.classList.add('is-in'); fire(el);} });
  }

  function initCountdown(root){
    qa('[data-vh-countdown]',root).forEach(function(el){
      if(el._t) clearInterval(el._t);
      var mins=parseInt(el.getAttribute('data-vh-countdown'),10)||15, key='vh_cd_'+(el.id||'x'), end;
      try{ end=parseInt(sessionStorage.getItem(key),10);}catch(e){}
      if(!end||end<Date.now()){ end=Date.now()+mins*60000; try{sessionStorage.setItem(key,end);}catch(e){} }
      var h=el.querySelector('[data-h]'),m=el.querySelector('[data-m]'),s=el.querySelector('[data-s]');
      function tick(){ var d=Math.max(0,end-Date.now()); if(d===0){ end=Date.now()+mins*60000; try{sessionStorage.setItem(key,end);}catch(e){} }
        var hh=Math.floor(d/3600000),mm=Math.floor(d%3600000/60000),ss=Math.floor(d%60000/1000);
        if(h)h.textContent=('0'+hh).slice(-2); if(m)m.textContent=('0'+mm).slice(-2); if(s)s.textContent=('0'+ss).slice(-2);}
      tick(); el._t=setInterval(tick,1000);
    });
  }

  function initTabs(root){
    qa('[data-vh-tabs]',root).forEach(function(w){
      var btns=qa('[data-tab]',w), panes=qa('[data-pane]',w);
      btns.forEach(function(b){ b.addEventListener('click',function(){
        var id=b.getAttribute('data-tab');
        btns.forEach(function(x){x.classList.toggle('is-on',x===b);});
        panes.forEach(function(p){p.classList.toggle('is-on',p.getAttribute('data-pane')===id);});
      });});
    });
  }

  function initSymptoms(root){
    qa('[data-vh-symptoms]',root).forEach(function(w){
      var cards=qa('.vh-sym',w), res=w.querySelector('.vh-symres'), cnt=w.querySelector('[data-vh-symcount]'), min=parseInt(w.getAttribute('data-min')||'2',10);
      cards.forEach(function(c){ c.addEventListener('click',function(){
        c.classList.toggle('is-on');
        var n=cards.filter(function(x){return x.classList.contains('is-on');}).length;
        if(cnt) cnt.textContent=n;
        if(res) res.classList.toggle('is-on', n>=min);
      });});
    });
  }

  function initSlider(root){
    qa('[data-vh-slider]',root).forEach(function(w){
      var tr=w.querySelector('.vh-slider__track'), slides=qa('.vh-slide',w), i=0;
      function per(){ return window.innerWidth<600?1:(window.innerWidth<900?2:3); }
      function go(n){ var max=Math.max(0,slides.length-per()); i=n<0?max:(n>max?0:n); tr.style.transform='translateX(-'+(i*100/per())+'%)'; }
      var p=w.querySelector('[data-prev]'),n=w.querySelector('[data-next]');
      if(p)p.onclick=function(){go(i-1);}; if(n)n.onclick=function(){go(i+1);};
      if(w._t) clearInterval(w._t);
      if(w.getAttribute('data-auto')==='true') w._t=setInterval(function(){go(i+1);},5500);
      window.addEventListener('resize',function(){go(i);});
    });
  }

  function initBA(root){
    qa('[data-vh-ba]',root).forEach(function(w){
      var b=qa('[data-ba]',w), p=qa('[data-ba-pane]',w);
      b.forEach(function(x){ x.addEventListener('click',function(){
        var k=x.getAttribute('data-ba'); b.forEach(function(y){y.classList.toggle('is-on',y===x);});
        p.forEach(function(y){y.classList.toggle('is-on',y.getAttribute('data-ba-pane')===k);});
      });});
    });
  }

  function money(cents,fmt){
    var v=(cents/100).toFixed(2);
    return (fmt||'${{amount}}').replace(/\{\{\s*amount\s*\}\}/,v).replace(/\{\{\s*amount_no_decimals\s*\}\}/,Math.round(cents/100));
  }

  function initBundles(root){
    qa('[data-vh-bundles]',root).forEach(function(w){
      var form=w.closest('form')||w.parentNode, opts=qa('.vh-bundle',w), idIn=form.querySelector('input[name="id"]'),
          qtyIn=form.querySelector('input[name="quantity"]'), stickyP=document.querySelector('[data-vh-sticky-price]');
      function pick(o){
        opts.forEach(function(x){ x.classList.toggle('is-on',x===o); var r=x.querySelector('input'); if(r) r.checked=(x===o); });
        if(idIn && o.getAttribute('data-variant')) idIn.value=o.getAttribute('data-variant');
        if(qtyIn) qtyIn.value=o.getAttribute('data-qty')||1;
        if(stickyP) stickyP.textContent=o.querySelector('.vh-bundle__now').textContent;
      }
      opts.forEach(function(o){ o.addEventListener('click',function(){pick(o);}); });
      var def=w.querySelector('.vh-bundle.is-on')||opts[0]; if(def) pick(def);
    });
  }

  function initGallery(root){
    qa('[data-vh-gallery]',root).forEach(function(g){
      var main=g.querySelector('.vh-gal__main img'), th=qa('.vh-gal__thumbs button',g);
      th.forEach(function(b){ b.addEventListener('click',function(){
        th.forEach(function(x){x.classList.toggle('is-on',x===b);}); if(main){ main.src=b.getAttribute('data-src'); main.srcset=''; }
      });});
    });
  }

  function initSticky(root){
    qa('[data-vh-sticky]',root).forEach(function(s){
      var target=document.querySelector(s.getAttribute('data-vh-sticky'));
      if(!target||!('IntersectionObserver' in window)) return;
      new IntersectionObserver(function(es){ es.forEach(function(e){ s.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top<0); }); }).observe(target);
      var btn=s.querySelector('button'); if(btn) btn.onclick=function(){ var f=target.querySelector('form')||target; var sb=f.querySelector('[type=submit]'); if(sb) sb.click(); else target.scrollIntoView({behavior:'smooth'}); };
    });
  }

  function initTrack(root){
    qa('[data-vh-track]',root).forEach(function(f){
      f.addEventListener('submit',function(ev){
        var base=f.getAttribute('data-url')||''; var num=(f.querySelector('[name=tracking]')||{}).value||'';
        if(base){ ev.preventDefault(); window.open(base.replace('NUMBER',encodeURIComponent(num.trim())),'_blank','noopener'); }
      });
    });
  }

  function init(root){ root=root||document; initReveal(root); initCountdown(root); initTabs(root); initSymptoms(root); initSlider(root); initBA(root); initBundles(root); initGallery(root); initSticky(root); initTrack(root); }
  window.VH = {init:init, money:money};
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded',function(){init();});
  document.addEventListener('shopify:section:load',function(e){ init(e.target); });
})();
